import type { ParseImageURLProps } from './types';

const MARKETPLACE_CDN_BASE = 'https://www.nerdwallet.com/';

const validImageExtensions = [
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'svg',
  'bmp',
  'ico',
  'tiff',
  'avif',
];

export function isValidImageExtension(imagePath: string) {
  const imageExtension = imagePath.split('.').pop();
  return validImageExtensions.includes(imageExtension || '');
}

export function parseImageURL({
  customImageWidth,
  customImageQuality,
  imagePath,
  alternateImageURL,
}: ParseImageURLProps) {
  const isCustomImageQualityValid = customImageQuality > 0 && customImageQuality <= 100;

  if (!isCustomImageQualityValid || !isValidImageExtension(imagePath)) {
    return alternateImageURL;
  }

  return `${MARKETPLACE_CDN_BASE}cdn-cgi/image/width=${customImageWidth || 300},quality=${
    customImageQuality || 80
  }/${imagePath}`;
}
